
import { Component, Mixins } from "vue-property-decorator";
import { IItemGroupSelectBehaviorPropertyEditable, instanceOfIItemGroupSelectBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";
import { IItemGroupSelectBehavior } from "../../../../../../documaker/domain/format/objects";

@Component
export default class ItemGroupSelectBehaviorPropertyEditableMixin extends Mixins() {
  writePropertyWhenValid: (writer: (source: IItemGroupSelectBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IItemGroupSelectBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isItemGroupSelectBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIItemGroupSelectBehaviorPropertyEditable(s) && s.itemGroupSelectBehavior().isEditable(), false);
  }

  get itemGroupSelectBehavior(): IItemGroupSelectBehavior {
    return this.readPropertyOrDefault(s => s.itemGroupSelectBehavior().getValue(), { groupName: "" });
  }

  set itemGroupSelectBehavior(value: IItemGroupSelectBehavior) {
    this.writePropertyWhenValid(s => s.itemGroupSelectBehavior().setValue(value));
  }
}
